import type { TFunction } from 'i18next';
import type { AdminAuditEvent } from 'api/adminAuditApi';

export type OpenEvent = (event: AdminAuditEvent, trigger: HTMLElement) => void;

// Grid template of design §6.4 — header and every row (top-level or child) share it so columns
// line up without an actual `<table>`, which cannot host the import row's disclosure smoothly.
export const GRID_COLS = 'grid-cols-[150px_170px_110px_minmax(180px,1.1fr)_140px_minmax(200px,1.6fr)]';

/** Muted-until-hover cell text (R-187): every `text-muted-foreground` table cell needs this. */
export const MUTED_CELL = 'text-muted-foreground group-hover:text-foreground';

export const CHILDREN_PAGE = 5;

/** The journal's known modules, in filter-select order. */
export const AUDIT_MODULES = ['technicians', 'quotas', 'interventions', 'referentials', 'users', 'groups'] as const;

/** One module's display label — the filter select and the table column share it (CA26). Literal
 * switch, not a lookup table: the repo's i18n guard only allows literal `t('...')` calls. */
export const moduleLabel = (t: TFunction, mod: string): string => {
  switch (mod) {
    case 'technicians':
      return t('Technicians');
    case 'quotas':
      return t('Quotas');
    case 'interventions':
      return t('Interventions');
    case 'referentials':
      return t('Referentials');
    case 'users':
      return t('Users');
    case 'groups':
      return t('Validation groups');
    default:
      return mod;
  }
};
